import React from "react";

import Button from '@material-ui/core/Button';
import FirstPageIcon from '@material-ui/icons/FirstPage';

export const ReturnListButton = (props) => {
	return <Button variant="contained" size="small" component="a" startIcon={<FirstPageIcon /> } {...props}>{props.label}</Button>;
}